<template>
  <div class="action-item-wrapper">
    <div class="lang-select">
         <span class="lang-select-btn" @click="langDialog = true">
            <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m470 180h-140.644531c.445312-4.933594.6875-9.929688.6875-14.980469 0-90.992187-74.03125-165.019531-165.023438-165.019531-28.984375 0-57.496093 7.625-82.453125 22.046875-4.78125 2.761719-6.417968 8.878906-3.65625 13.660156 2.765625 4.785157 8.882813 6.417969 13.664063 3.65625 21.917969-12.667969 46.96875-19.363281 72.445312-19.363281 79.964844 0 145.023438 65.054688 145.023438 145.019531 0 79.964844-65.058594 145.023438-145.023438 145.023438-33.472656 0-64.917969-11.089844-90.9375-32.066407-2.609375-2.101562-6.066406-2.730468-9.214843-1.765624l-26.542969 6.941406 10.398437-22.851563c1.496094-3.28125 1.105469-7.109375-1.015625-10.027343-18.125-24.894532-27.707031-54.375-27.707031-85.253907 0-25.542969 6.730469-50.65625 19.464844-72.621093 2.769531-4.78125 1.140625-10.898438-3.636719-13.667969s-10.894531-1.144531-13.667969 3.636719c-14.496094 25.007812-22.160156 53.589843-22.160156 82.652343 0 33.160157 9.714844 64.914063 28.152344 92.199219l-16.742188 36.785156c-1.601562 3.511719-1.035156 7.628906 1.449219 10.582032 2.484375 2.953124 6.445313 4.210937 10.179687 3.234374l42.527344-11.117187c28.507813 21.535156 63.621094 33.339844 99.453125 33.339844 7.800781 0 15.46875-.558594 22.980469-1.609375v87.566406c0 23.15625 18.839844 42 41.996094 42h141.433594l63.238281 51.738281c1.820312 1.492188 4.066406 2.257813 6.332031 2.257813 1.457031 0 2.917969-.316406 4.28125-.960938 3.492188-1.65625 5.71875-5.171875 5.71875-9.039062v-43.996094h19c23.160156 0 42-18.84375 42-42v-194c0-23.160156-18.839844-42-42-42zm22 236c0 12.128906-9.867188 22-22 22h-29c-5.523438 0-10 4.476562-10 10v32.894531l-49.390625-40.410156c-2.722656-2.484375-5.105469-2.484375-10.460937-2.484375h-141.152344c-12.128906 0-21.996094-9.871094-21.996094-22v-91.648438c59.152344-15.972656 105.238281-64.074218 118.296875-124.351562h143.703125c12.132812 0 22 9.867188 22 22zm0 0"/><path d="m399.761719 348.605469c3.390625-1.597657 5.742187-5.039063 5.742187-9.039063 0-5.519531-4.476562-10-10-10h-4.09375l-32.25-73.5c-1.597656-3.636718-5.191406-5.984375-9.160156-5.984375s-7.5625 2.347657-9.15625 5.984375l-32.25 73.5h-4.09375c-5.523438 0-10 4.480469-10 10 0 4 2.351562 7.441406 5.742188 9.039063l-12.011719 27.375c-2.21875 5.058593.082031 10.957031 5.136719 13.175781 5.058593 2.21875 10.957031-.082031 13.175781-5.140625l15.117187-34.449219h56.683594l15.117188 34.449219c1.644531 3.75 5.3125 5.984375 9.164062 5.984375 1.339844 0 2.703125-.269531 4.011719-.84375 5.054687-2.21875 7.359375-8.117188 5.136719-13.175781zm-69.328125-19.039063 19.566406-44.59375 19.566406 44.59375zm0 0"/><path d="m55.402344 65.398438c2.628906 0 5.207031-1.070313 7.070312-2.929688 1.859375-1.859375 2.929688-4.4375 2.929688-7.070312 0-2.628907-1.070313-5.207032-2.929688-7.070313-1.863281-1.859375-4.441406-2.929687-7.070312-2.929687-2.640625 0-5.210938 1.070312-7.070313 2.929687-1.859375 1.863281-2.929687 4.441406-2.929687 7.070313 0 2.632812 1.070312 5.210937 2.929687 7.070312 1.859375 1.863281 4.4375 2.929688 7.070313 2.929688zm0 0"/><path d="m105.328125 225.878906c-4.84375 2.65625-6.617187 8.734375-3.960937 13.578125 1.820312 3.316407 5.246093 5.195313 8.777343 5.195313 1.625 0 3.273438-.398438 4.800781-1.234375 22.300782-12.230469 39.457032-31.253907 49.492188-53.6875 10.039062 22.433593 27.191406 41.457031 49.492188 53.6875 1.527343.835937 3.175781 1.234375 4.800781 1.234375 3.53125 0 6.957031-1.878906 8.777343-5.195313 2.65625-4.84375.882813-10.921875-3.960937-13.578125-26.105469-14.316406-43.675781-39.902344-48.039063-68.8125h44.398438c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-45.46875v-41.671875c0-5.523437-4.476562-10-10-10s-10 4.476563-10 10v41.671875h-36.125c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10h35.054688c-4.363282 28.910156-21.933594 54.5-48.039063 68.8125zm0 0"/></svg>
          </span>
    </div>
    <div class="action-item" @click="$store.state.core.featuresStatus.speechToText = !$store.state.core.featuresStatus.speechToText " :class="{active: $store.state.core.featuresStatus.speechToText }">
      <div class="active-action item" v-if="$store.state.core.featuresStatus.speechToText ">
        <span class="icon-check"></span>
      </div>


      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div
              v-bind="attrs"
              v-on="on"
          >
            <div v-html="icons.speechToText"></div>
            <h3>{{$t('Speak to Inputs')}}</h3>
          </div>
        </template>
        <span>{{$t('Select input field to start speak')}}</span>
      </v-tooltip>
    </div>
    <v-dialog v-model="langDialog" width="500">
      <translation-dialog @closeDialog="langDialog = false"/>
    </v-dialog>
    <v-snackbar
        v-model="recorederDialog"
        :timeout="200000"
        color="primary"
        class="recoreder-snack"
    >
      {{ $t('Start speak to the input field') }}


      <div>
        <v-btn
            color="white"
            dark
            text
            @click="initRecording"
            :loading="loadingVoice"
            v-if="!isRecording"
        >
          <span v-html="icons.play" class="svg-icon"></span>
        </v-btn>

        <v-btn
            v-else
            color="white"
            dark
            text
            @click="stopAudio"
        >
          <span v-html="icons.stop" class="svg-icon"></span>
        </v-btn>

          <span     @click="endRecord"
                    class="snack-close svg-icon" v-html="icons.close"></span>

      </div>



    </v-snackbar>
  </div>

</template>


<script>
import translationDialog from "@/components/selectors/translationDialog";
import Recorder from 'recorder-js';
import {icons} from '../../utils/icons'
export default {
  name: "translate",
  components: {
    translationDialog
  },
  data() {
    return {
      active: false,
      icons,
      audioObject: new Audio(),
      text: '',
      selectedLang: null,
      currentInput: null,
      langDialog: false,
      recorederDialog: false,
      loadingVoice: false,
      isRecording: false
    }
  },
  props: {
    data: {
      type: Object,
      default: ()=> {
        return {}
      }
    }
  },
  mounted() {
    let textFields =document.getElementsByTagName("input");
    let textAreas = document.getElementsByTagName("textarea");
    let inputs = [...textFields , ...textAreas]

    for(let i=0;i<inputs.length;i++)
    {
      inputs[i].addEventListener('focus',()=>{
        this.currentInput = inputs[i]
        if (this.$store.state.core.featuresStatus.speechToText) {
          this.recorederDialog = true

        }
      });
      // inputs[i].addEventListener('blur', ()=> {
      //   this.recorederDialog = false
      //   if (this.recorder) {
      //     this.stopAudio()
      //   }
      //
      // })
    }

  },
  methods: {
    setValue() {

    },
    initRecording() {
      const audioContext =  new (window.AudioContext || window.webkitAudioContext)();

      this.recorder = new Recorder(audioContext, {
        // An array of 255 Numbers
        // You can use this to visualize the audio stream
        // If you use react, check out react-wave-stream

      });


      navigator.mediaDevices.getUserMedia({audio: true})
          .then(stream => {
            this.recorder.init(stream)
            this.recorder.start()
            this.isRecording = true
          })
          .catch(() => {});
    },
    stopAudio() {
      this.recorder.stop()
          .then(({blob}) => {
            this.isRecording = false
            this.loadingVoice = true
            this.blob = blob;
            let fd = new FormData();
            fd.append("audio", blob, new Date().toISOString()+'.wav');
            fd.append('lang', this.$store.state.core.featuresStatus.speechToTextLang.source);
            fd.append('dst_lang ', this.$store.state.core.featuresStatus.speechToTextLang.target);
            this.speechToText(fd)
            // buffer is an AudioBuffer
          });//stop microphone access
    },
    speechToText(fd){
      this.audioObject.pause()
      this.$http_ist.post('/speech-to-text', fd)
          .then(response=>{
              this.currentInput.value = this.currentInput.value + response.data.data
          })
          .catch(()=>{

          })
      .finally(()=> {
        this.loadingVoice = false
      })

    },
    endRecord () {
      this.recorederDialog = false
      this.loadingVoice = false
      this.isRecording = false
    }
  },
  watch: {
    '$store.state.core.featuresStatus.speechToText': function (state) {
      localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
      if (state) {
        this.$emit('countAnalytics', this.data._id)

      }
    }
  }
}
</script>

<style  lang="scss">
.v-snack__content {
  position: relative;
  overflow: visible !important;
  .snack-close {
    background: #eeeeee;
    position: absolute;
    top: 0;
    transform: translate(50% , -50%);
    right: 0;
    padding: 5px;
    height: 20px;
    display: flex;
    align-items: center;
    width: 20px;
    border-radius: 100%;
    cursor: pointer;
    svg {
      height: 10px;
      width: 10px;
      fill: #aaa;
    }
  }
}

</style>
